
import React, { useEffect, useState } from 'react';
import { Button, Form, Select, Modal, message } from 'antd';
import { Colors } from '../../helpers/Colors';
import { gellAllLocomotiveLocations, getAllLocomotive, getTicketCategory, updateLocomotiveTicketModal, updateTicketCategory } from '../../Services/LocomotiveServices';
import { seriliazeParams } from '../../helpers/seriliazeParams';

const LocomotiveTicketModal = ({ open, close, TicketTypeId, data = { label: { name: "Null", values: {} } } }) => {
    const [form] = Form.useForm();
    const [Location, setLocation] = useState([]);
    const [EquipId, setEquipId] = useState([]);
    const [TicketCategory, setTicketCategory] = useState([]);
    const [selectedValue, setSelectedValue] = useState(null);

    const getSiteLocation = async () => {
        let params = '?'.concat(seriliazeParams({
            locationType: 'LOC,ALL'
        }))
        const result = await gellAllLocomotiveLocations({ params });
        if (result?.httpStatus === 200) {
            const data = result?.data.map((item, index) => ({
                label: item?.title,
                value: item?.id
            }));
            setLocation(data);
        }
    };

    const getEquipID = async () => {
        const result = await getAllLocomotive();
        if (result.httpStatus === 200) {
            const data = result?.data.map((item, index) => ({
                label: item?.EquipUID,
                value: item?.id
            }));
            setEquipId(data);
        }
    };

    const getTicketCategories = async () => {
        if (!TicketTypeId) return;

        const apiFunction = data?.label?.key === 'categoryName' ? updateTicketCategory : getTicketCategory;

        const result = await apiFunction(TicketTypeId);

        if (result.httpStatus === 200) {
            const data = result?.data.map((item, index) => ({
                label: item?.name,
                value: item?.id
            }));
            setTicketCategory(data);
        }
    };

    const onChange = (value) => {
        // Any other logic you want to perform on value change
    };

    const filterOption = (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const Filter = (value, type) => {
        if (type === 'Location') {
            if (value?.name === data?.values?.TGSLocation?.name) {
                const id = Location.findIndex(item => item?.label === value?.name)
                return Location[id].value
            }
            return value.name;
        } else {
            if (value?.name === data?.values?.EquipId?.name) {
                const id = EquipId.findIndex(item => item.label === value?.name)
                return EquipId[id].value
            }
            return value.name;
        }
    };

    const handleSubmit = async (values) => {
        let dataObj;

        if (values?.location) {
            dataObj = {
                ...dataObj,
                LocationId: Filter({ name: values?.location ? values?.location : false }, 'Location'),
            };
        }

        if (values?.EquipUID) {
            dataObj = {
                ...dataObj,
                EquipMasterId: Filter({ name: values?.EquipUID ? values?.EquipUID : false }, 'EquipId'),
            };
        }

        const apiFunction = data?.label?.key === 'categoryName' ? updateTicketCategory : updateLocomotiveTicketModal;
        const payload = data?.label?.key === 'categoryName' ? { "TicketCategoryId": values[data?.label?.key] } : dataObj;

        const result = await apiFunction(data?.values?.id, payload);

        if (result?.httpStatus === 200) {
            message.success(`${data?.label?.name} updated successfully!`);
            close();
        }
    };

    useEffect(() => {
        getSiteLocation();
        getEquipID();
        getTicketCategories();
    }, []);

    useEffect(() => {
        getTicketCategories();
    }, [TicketTypeId]);

    useEffect(() => {
        form.setFieldsValue({
            EquipUID: data?.values?.EquipId?.EquipUID,
            location: data?.values?.TGSLocation?.name,
            categoryName: data?.values?.TicketCategory?.name
        });

    }, [data]);

    return (
        <Modal title={<p style={{ color: Colors.mainBlue, fontWeight: "600", marginBottom: "0px ", fontSize: "20px" }}>Update {data?.label?.name}</p>} open={open} onCancel={() => { close() }} footer={null} >
            <Form
                name='Locomotive Ticket Form'
                onFinish={(values) => { handleSubmit(values) }}
                form={form}
            >
                {
                    data?.values &&
                    <>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: "10px" }}>
                            <p style={{ width: "150px", fontSize: "16px", fontWeight: "700", whiteSpace: "nowrap", marginBottom: "0px" }}>{data?.label?.name}</p>
                            <Form.Item name={data?.label?.key} rules={[{ required: true, message: "Kindly enter value" }]} style={{ margin: "0px" }}>
                                <Select
                                    style={{ width: "350px" }}
                                    showSearch
                                    optionFilterProp="children"

                                    onChange={onChange}
                                    filterOption={filterOption}
                                    placeholder={`Select ${data?.label?.name}`}
                                    options={data?.label?.key === 'EquipUID' ? EquipId : data?.label?.key === 'categoryName' ? TicketCategory : Location}

                                />
                            </Form.Item>
                        </div>

                        <div style={{ display: "flex", justifyContent: "end" }} >
                            <Button htmlType='submit' style={{ background: Colors.mainBlue, color: "white", border: "none", marginTop: "30px" }}>Update</Button>
                        </div>
                    </>
                }
            </Form>
        </Modal>
    );
};

export default LocomotiveTicketModal;

